import { AxiosError } from 'axios';
import http, { Http } from '@/lib/http';

type Args = {
  orderId: string;
  projectId: string;
  amountInCents?: number;
};

function ctor(http: Http) {
  return async ({ orderId, projectId, amountInCents }: Args): Promise<void> => {
    try {
      await http.post<void>(
        `/projects/${projectId}/loans/${orderId}/off-schedule-payment`,
        {
          amountInCents,
        },
      );
    } catch (err) {
      throw (err as AxiosError).response?.data;
    }
  };
}

export const payOffSchedule = ctor(http);
